import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=ef8a5e8e&scoped=true"
import script from "./perfil.vue?vue&type=script&lang=ts"
export * from "./perfil.vue?vue&type=script&lang=ts"
import style0 from "./perfil.vue?vue&type=style&index=0&id=ef8a5e8e&prod&lang=scss"
import style1 from "./perfil.vue?vue&type=style&index=1&id=ef8a5e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8a5e8e",
  null
  
)

export default component.exports